import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConectService {

  constructor(private http: HttpClient) { }


  sendEmail(data: Array<string>) {
    return this.http.post(`https://galmoro.com/php/sendEmail.php`, JSON.stringify(data));
  }
}
